module.exports = __webpack_public_path__ + "assets/img/22_285_big.98f3c05d.jpg";